import { render, staticRenderFns } from "./CircleWithInitialsNew.vue?vue&type=template&id=0604900c&scoped=true"
import script from "./CircleWithInitialsNew.vue?vue&type=script&lang=ts"
export * from "./CircleWithInitialsNew.vue?vue&type=script&lang=ts"
import style0 from "./CircleWithInitialsNew.vue?vue&type=style&index=0&id=0604900c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604900c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0604900c')) {
      api.createRecord('0604900c', component.options)
    } else {
      api.reload('0604900c', component.options)
    }
    module.hot.accept("./CircleWithInitialsNew.vue?vue&type=template&id=0604900c&scoped=true", function () {
      api.rerender('0604900c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CircleWithInitialsNew.vue"
export default component.exports